<script>
  import ReceiptBarcode from './ReceiptBarcode.svelte';
  import ReceiptDivider from './ReceiptDivider.svelte';

  let {
    title,
    subtitle = '',
    receiptNo = '',
    date = '',
    showBarcode = true,
  } = $props();
</script>

<div class="receipt-header">
  <h2 class="receipt-header__title">{title}</h2>

  {#if subtitle}
    <p class="receipt-header__subtitle">{subtitle}</p>
  {/if}

  {#if receiptNo || date}
    <div class="receipt-header__meta">
      {#if receiptNo}
        <span class="receipt-header__meta-line">NO. {receiptNo}</span>
      {/if}
      {#if date}
        <span class="receipt-header__meta-line">{date}</span>
      {/if}
    </div>
  {/if}

  {#if showBarcode && receiptNo}
    <div class="receipt-header__barcode">
      <ReceiptBarcode code={receiptNo} />
    </div>
  {/if}

  <ReceiptDivider variant="double" spacing="sm" />
</div>

<style>
  .receipt-header {
    text-align: center;
    width: 100%;
  }

  .receipt-header__title {
    font-family: var(--font-mono);
    font-size: 26px;
    font-weight: 900;
    letter-spacing: 6px;
    text-transform: uppercase;
    color: var(--receipt-text-primary);
    margin: 0 0 4px;
    line-height: 1.3;
  }

  .receipt-header__subtitle {
    font-family: var(--font-mono);
    font-size: 13px;
    color: var(--receipt-text-muted);
    letter-spacing: 1px;
    margin: 0 0 8px;
  }

  .receipt-header__meta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
    margin-bottom: 8px;
  }

  .receipt-header__meta-line {
    font-family: var(--font-mono);
    font-size: 11px;
    color: var(--receipt-text-muted);
    letter-spacing: var(--receipt-ls-code, 1px);
  }

  .receipt-header__barcode {
    margin: 8px 0;
  }
</style>
